import * as Sentry from '@sentry/react';
import { config } from 'utils/config';

const envMap = {
  production: 'prod',
  development: 'dev',
  staging: 'stg',
};

if (!config.isDev) {
  Sentry.init({
    dsn: 'https://725ece12b8b3db854cbfd69b8c5f71fc@o4509004560138240.ingest.de.sentry.io/4509322109780048',
    environment: config.env.VITE_ENV ? envMap[config.env.VITE_ENV as keyof typeof envMap] : undefined,

    integrations: [
      Sentry.replayIntegration({ maskAllText: true, maskAllInputs: true }),
      Sentry.httpClientIntegration(),
    ],

    // Capture Replay for 10% of all sessions,
    // plus for 100% of sessions with an error
    // Learn more at
    // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
